import _ from 'lodash';
import type { TableDocumentColumn, TableDocumentRow } from './types';
import type {
  ColumnSelection,
  RowSelection,
  TableSelection,
} from './useTableSelection';
import { SelectionType } from './useTableSelection';

type RangeSelection = TableSelection | RowSelection | ColumnSelection;

const getRangeSelectionIndexes = (
  selection: RangeSelection,
  {
    rows = [],
    columns = [],
  }: { rows?: TableDocumentRow[]; columns?: TableDocumentColumn[] },
) => {
  let rowIndexes: number[] = [];
  let columnIndexes: number[] = [];
  switch (selection.type) {
    case SelectionType.Table:
      rowIndexes = _.range(rows.length);
      columnIndexes = _.range(columns.length);
      break;
    case SelectionType.Row:
      rowIndexes = selection.rows.slice().sort((a, b) => a - b);
      columnIndexes = _.range(columns.length);
      break;
    case SelectionType.Column:
      rowIndexes = _.range(rows.length);
      columnIndexes = selection.columns.slice().sort((a, b) => a - b);
      break;
    default:
      break;
  }

  return { rowIndexes, columnIndexes };
};

export default getRangeSelectionIndexes;
